var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main" }, [
    _c(
      "h3",
      { staticClass: "title", attrs: { content: "edit", placement: "bottom" } },
      [
        _vm._v("\n    Content Management - Our Products\n    "),
        _vm.$store.state.userLevel <= 2
          ? _c(
              "el-button",
              {
                staticStyle: { width: "180px" },
                attrs: { type: "primary" },
                on: {
                  click: function($event) {
                    return _vm.handleAdd()
                  }
                }
              },
              [_vm._v("Create")]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "search-toggle",
            on: {
              click: function($event) {
                _vm.searchExpanded = !_vm.searchExpanded
              }
            }
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(_vm.searchExpanded ? "Hide Filters" : "Show Filters") +
                "\n      "
            ),
            _c("em", {
              staticClass: "el-icon-arrow-up",
              class: { "is-collapsed": !_vm.searchExpanded }
            })
          ]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.searchExpanded,
            expression: "searchExpanded"
          }
        ],
        staticClass: "searchBox"
      },
      [
        _c(
          "el-form",
          {
            ref: "formInline",
            staticClass: "demo-form-inline",
            attrs: { model: _vm.formInline }
          },
          [
            _c(
              "div",
              { staticClass: "search-grid" },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "projectName" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "Project Name", maxlength: "50" },
                      nativeOn: {
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.submitSearch.apply(null, arguments)
                        }
                      },
                      model: {
                        value: _vm.formInline.projectName,
                        callback: function($$v) {
                          _vm.$set(_vm.formInline, "projectName", $$v)
                        },
                        expression: "formInline.projectName"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { prop: "projectCode" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "Project Code", maxlength: "50" },
                      nativeOn: {
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.submitSearch.apply(null, arguments)
                        }
                      },
                      model: {
                        value: _vm.formInline.projectCode,
                        callback: function($$v) {
                          _vm.$set(_vm.formInline, "projectCode", $$v)
                        },
                        expression: "formInline.projectCode"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "search-toolbar" }, [
          _c(
            "div",
            { staticClass: "search-toolbar__actions" },
            [
              _c(
                "el-button",
                {
                  staticClass: "search",
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.submitSearch("search")
                    }
                  }
                },
                [_vm._v("Search")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "reset",
                  on: {
                    click: function($event) {
                      return _vm.resetForm("formInline")
                    }
                  }
                },
                [_vm._v("Reset")]
              )
            ],
            1
          )
        ])
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "client-panel" },
      [
        _c("div", { staticClass: "client-panel__toolbar" }, [
          _c(
            "div",
            { staticClass: "search-toolbar__extra" },
            [
              _c("columns-control", {
                attrs: {
                  columns: _vm.columnsConfig,
                  "storage-key": "cms.ourProducts.columns"
                },
                on: { change: _vm.onColumnsChange }
              }),
              _vm._v(" "),
              _c(
                "el-dropdown",
                { ref: "filter", attrs: { trigger: "click" } },
                [
                  _c("span", { staticClass: "el-dropdown-link sortbox" }, [
                    _c("em", { staticClass: "filter" }),
                    _vm._v("\n          Filter\n        ")
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-dropdown-menu",
                    { attrs: { slot: "dropdown" }, slot: "dropdown" },
                    [
                      _c(
                        "el-form",
                        {
                          ref: "formFilter",
                          staticStyle: { width: "300px", padding: "14px 24px" },
                          attrs: { model: _vm.formFilter }
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { "margin-bottom": "12px" },
                              attrs: { label: "Project Type", prop: "type" }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { "popper-append-to-body": false },
                                  model: {
                                    value: _vm.formFilter.type,
                                    callback: function($$v) {
                                      _vm.$set(_vm.formFilter, "type", $$v)
                                    },
                                    expression: "formFilter.type"
                                  }
                                },
                                [
                                  _c("el-option", { attrs: { value: "All" } }, [
                                    _vm._v("All")
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(_vm.typeList, function(item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: item.name,
                                        value: item.code
                                      }
                                    })
                                  })
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { "margin-bottom": "12px" },
                              attrs: {
                                label: "Project Location",
                                prop: "location"
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { "popper-append-to-body": false },
                                  model: {
                                    value: _vm.formFilter.location,
                                    callback: function($$v) {
                                      _vm.$set(_vm.formFilter, "location", $$v)
                                    },
                                    expression: "formFilter.location"
                                  }
                                },
                                [
                                  _c("el-option", { attrs: { value: "All" } }, [
                                    _vm._v("All")
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(_vm.locationList, function(
                                    item,
                                    index
                                  ) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: item.name,
                                        value: item.code
                                      }
                                    })
                                  })
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { "margin-bottom": "12px" },
                              attrs: {
                                label: "Project Status",
                                prop: "projectStatus"
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { "popper-append-to-body": false },
                                  model: {
                                    value: _vm.formFilter.projectStatus,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formFilter,
                                        "projectStatus",
                                        $$v
                                      )
                                    },
                                    expression: "formFilter.projectStatus"
                                  }
                                },
                                [
                                  _c("el-option", { attrs: { value: "All" } }, [
                                    _vm._v("All")
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(_vm.statusList, function(item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: item.name,
                                        value: item.code
                                      }
                                    })
                                  })
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { "margin-bottom": "12px" },
                              attrs: {
                                label: "Post Status",
                                prop: "postStatus"
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { "popper-append-to-body": false },
                                  model: {
                                    value: _vm.formFilter.postStatus,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formFilter,
                                        "postStatus",
                                        $$v
                                      )
                                    },
                                    expression: "formFilter.postStatus"
                                  }
                                },
                                [
                                  _c("el-option", { attrs: { value: "All" } }, [
                                    _vm._v("All")
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(_vm.postList, function(item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: item.name,
                                        value: item.code
                                      }
                                    })
                                  })
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { "margin-bottom": "12px" },
                              attrs: { label: "Project Code" }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { "popper-append-to-body": false },
                                  model: {
                                    value: _vm.formFilter.code,
                                    callback: function($$v) {
                                      _vm.$set(_vm.formFilter, "code", $$v)
                                    },
                                    expression: "formFilter.code"
                                  }
                                },
                                [
                                  _c("el-option", { attrs: { value: "All" } }, [
                                    _vm._v("All")
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(_vm.ProductsList, function(
                                    item,
                                    index
                                  ) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: item.name,
                                        value: item.code
                                      }
                                    })
                                  })
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "filterButton" },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticStyle: {
                                    "margin-right": "15px",
                                    "margin-bottom": "0"
                                  }
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "reset",
                                      on: {
                                        click: function($event) {
                                          _vm.$refs.filter.hide()
                                          _vm.resetForm("formFilter")
                                        }
                                      }
                                    },
                                    [_vm._v("Reset")]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                { staticStyle: { "margin-bottom": "0" } },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "search",
                                      attrs: { type: "primary" },
                                      on: {
                                        click: function() {
                                          _vm.$refs.filter.hide()
                                          _vm.submitSearch("apply")
                                        }
                                      }
                                    },
                                    [_vm._v("Apply")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-dropdown",
                {
                  attrs: { trigger: "click" },
                  on: { command: _vm.handleCommand }
                },
                [
                  _c("span", { staticClass: "el-dropdown-link sortbox" }, [
                    _c("em", { staticClass: "sort" }),
                    _vm._v("\n          Sort by\n        ")
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-dropdown-menu",
                    { attrs: { slot: "dropdown" }, slot: "dropdown" },
                    [
                      _c(
                        "el-dropdown-item",
                        { attrs: { command: ["name.EN,asc", "id,asc"] } },
                        [_vm._v("Project name (A-Z)")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-dropdown-item",
                        { attrs: { command: ["name.EN,desc", "id,asc"] } },
                        [_vm._v("Project name (Z-A)")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c(
          "el-table",
          { attrs: { data: _vm.tableData } },
          [
            _vm.isColumnVisible("projectId")
              ? _c("el-table-column", {
                  attrs: { prop: "projectId", label: "Project ID" }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isColumnVisible("salesOffice")
              ? _c("el-table-column", {
                  attrs: { label: "Sales Office" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              _vm._s(
                                _vm.$commonjs.salesOfficeMap(
                                  scope.row.salesOffice
                                )
                              )
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    4066695550
                  )
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isColumnVisible("region")
              ? _c("el-table-column", {
                  attrs: { label: "Region" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              _vm._s(_vm.handleTableRegion(scope.row.region))
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    3999917992
                  )
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isColumnVisible("productType")
              ? _c("el-table-column", {
                  attrs: { prop: "productType", label: "Product type" }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isColumnVisible("projectCode")
              ? _c("el-table-column", {
                  attrs: { prop: "projectCode", label: "Project Code" }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isColumnVisible("projectName")
              ? _c("el-table-column", {
                  attrs: { label: "Project Name" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            scope.row.name.EN
                              ? _c("p", [_vm._v(_vm._s(scope.row.name.EN))])
                              : _vm._e(),
                            _vm._v(" "),
                            scope.row.name.JA
                              ? _c("p", [_vm._v(_vm._s(scope.row.name.JA))])
                              : _vm._e(),
                            _vm._v(" "),
                            scope.row.name.ZH_HK
                              ? _c("p", [_vm._v(_vm._s(scope.row.name.ZH_HK))])
                              : _vm._e(),
                            _vm._v(" "),
                            scope.row.name.ZH_CN
                              ? _c("p", [_vm._v(_vm._s(scope.row.name.ZH_CN))])
                              : _vm._e()
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    156329072
                  )
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isColumnVisible("projectLocation")
              ? _c("el-table-column", {
                  attrs: { label: "Project Country" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              _vm._s(
                                _vm.$commonjs.locationMap(
                                  scope.row.projectLocation
                                )
                              )
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    4056364363
                  )
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isColumnVisible("projectState")
              ? _c("el-table-column", {
                  attrs: { prop: "status", label: "Project State" }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isColumnVisible("projectRegion")
              ? _c("el-table-column", {
                  attrs: { prop: "projectRegion", label: "Project Region" }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isColumnVisible("projectStatus")
              ? _c("el-table-column", {
                  attrs: { label: "Project Status", width: "150" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("div", { staticClass: "statusBox" }, [
                              _c("span", { staticStyle: { width: "100%" } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$commonjs.projectStatusMap(
                                      scope.row.status
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              scope.row.isNew
                                ? _c("span", { staticClass: "new_tag" }, [
                                    _vm._v("NEW")
                                  ])
                                : _vm._e()
                            ])
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    1687514531
                  )
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isColumnVisible("isPost")
              ? _c("el-table-column", {
                  attrs: { label: "Post" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              _vm._s(scope.row.isPost ? "Online" : "Offline")
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    1872787572
                  )
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isColumnVisible("lastPostDate")
              ? _c("el-table-column", {
                  attrs: { label: "Last Post Date" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              _vm._s(
                                scope.row.lastStartDate && scope.row.lastEndDate
                                  ? scope.row.lastStartDate +
                                      " ~ " +
                                      scope.row.lastEndDate
                                  : "-"
                              )
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    595565067
                  )
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isColumnVisible("updatedAt")
              ? _c("el-table-column", {
                  attrs: {
                    prop: "updatedAt",
                    label: "Last update",
                    formatter: _vm.$commonjs.tableFormatDateTime
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "Operation" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: {
                            effect: "dark",
                            content: "Edit",
                            placement: "top"
                          }
                        },
                        [
                          _c("em", {
                            staticClass: "edit",
                            staticStyle: { "margin-right": "10px" },
                            on: {
                              click: function($event) {
                                return _vm.handleEdit(scope.row)
                              }
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: {
                            effect: "dark",
                            content: "Delete",
                            placement: "top"
                          }
                        },
                        [
                          _c("em", {
                            staticClass: "delete",
                            on: {
                              click: function($event) {
                                return _vm.handleDelete(scope.row)
                              }
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "mini" },
                          on: {
                            click: function($event) {
                              return _vm.handleAddClone(scope.row)
                            }
                          }
                        },
                        [_vm._v("Clone")]
                      )
                    ]
                  }
                }
              ])
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("app-pagination", {
          attrs: {
            "current-page": _vm.currentPage,
            "page-sizes": [5, 10, 20, 50],
            total: _vm.total,
            "page-size": _vm.currentSize
          },
          on: {
            "size-change": function(v) {
              _vm.currentSize = v
              _vm.currentPage = 1
              _vm.getList()
            },
            "current-change": function(v) {
              _vm.currentPage = v
              _vm.getList()
            }
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8d4bf38c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8d4bf38c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/product/ourProducts.vue
// module id = null
// module chunks = 